import LocalStorageUtils from './local-storage';

export const useUser = () => {
  const userJSON = LocalStorageUtils.getValueFromLocalStorage('user');
  const user = typeof userJSON === 'string' ? JSON.parse(userJSON) : {};

  return user;
};
